import styled from "styled-components"

export const ContactLink = styled.a`
  font-family: "sharp_groteskmedium_20";
  font-size: ${({ fontSize }) => (fontSize ? fontSize : "16px")};
  color: #fff;
  text-align: center;
  text-decoration: none;
  display: block;
  margin-bottom: 20px;
  @media screen and (max-width: 576px) {
    font-size: 14px;
  }
`
